import Tr from 'translations/Translations';

const createItem = (trKey, value) => ({label: Tr(trKey), value})

export default [
	createItem('p1s1_ot_1', 'supplies'),
	createItem('p1s1_ot_2', 'services'),
	createItem('p1s1_ot_3', 'works'),
]